import React from "react";
import T from "prop-types";
import {
  ImprovedDropDown as DropDown,
  ImprovedDropDownItem as DropDownItem
} from "MODULES/shared/components/DropDown";
import CancelModal from "MODULES/Lots/Detail/LineItemsTable/CancelModal";

export function LineItemControls({ lineItem }) {
  const received = lineItem.quantity_received > 0;

  if (received || lineItem.cancelled) return null;

  return (
    <div>
      <DropDown>
        <DropDownItem
          id="cancel"
          label="Cancel Line Item"
          faIcon="ban"
          hideIf={lineItem.cancelled || lineItem.received}
          renderActive={<CancelModal lineItem={lineItem} />}
        />
      </DropDown>
    </div>
  );
}

LineItemControls.propTypes = {
  lineItem: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/LineItemsTable/LineItemControls.jsx